import clientService from '@services/client';

export const getLocationsOfClientSuccess = (locations) => ({
  type: 'CLIENT_LOCATIONS_SUCCESS',
  locations,
});

export const getLocationsClientError = (error) => ({
  type: 'CLIENT_LOCATIONS_FAILURE',
  error,
});

export const getLocationsOfClient = () =>
  function (dispatch) {
    dispatch({
      type: 'CLIENT_LOCATIONS_REQUEST',
    });
    return clientService.getLocationsByClientId();
  };
